import { gql } from 'react-apollo';

export default gql`
  mutation updateWefunderInvestorSuitability(
    $liquidityNeeds: LiquidityNeeds!
    $riskTolerance: RiskTolerance!
    $yearsOfExperience: YearsOfExperience!
    $investmentFrequency: InvestmentFrequency!
    $investmentAllocation: Float!
    $investmentDecisionConsultProfessional: Boolean
    $investmentDecisionConsultSelf: Boolean
    $investmentDecisionConsultFamilyFriends: Boolean
    $investmentSelectionsConfirmed: Boolean
    $investmentSelectionsWefunderPrecentage: Boolean
    $investmentSelectionsRelationshipConfirmed: Boolean
    $userId: ID
  ) {
    updateWefunderInvestorSuitability(
      input: {
        liquidityNeeds: $liquidityNeeds
        riskTolerance: $riskTolerance
        yearsOfExperience: $yearsOfExperience
        investmentFrequency: $investmentFrequency
        investmentAllocation: $investmentAllocation
        investmentDecisionConsultProfessional: $investmentDecisionConsultProfessional
        investmentDecisionConsultSelf: $investmentDecisionConsultSelf
        investmentDecisionConsultFamilyFriends: $investmentDecisionConsultFamilyFriends
        investmentSelectionsConfirmed: $investmentSelectionsConfirmed
        investmentSelectionsWefunderPrecentage: $investmentSelectionsWefunderPrecentage
        investmentSelectionsRelationshipConfirmed: $investmentSelectionsRelationshipConfirmed
        userId: $userId
      }
    ) {
      _id
      suitability {
        _id
        liquidityNeeds
        riskTolerance
        yearsOfExperience
        investmentFrequency
        investmentAllocation
        investmentDecisionConsultProfessional
        investmentDecisionConsultSelf
        investmentDecisionConsultFamilyFriends
        investmentSelectionsConfirmed
        investmentSelectionsWefunderPrecentage
        investmentSelectionsRelationshipConfirmed
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/mutations/updateWefunderInvestorSuitability.js